// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomPromptsList_wrapper__GVnEl"};